import React from "react";
import { connect } from "react-redux";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { deletePodcast } from "../../redux/actions/articles";

const DeleteForm = ({
  deletePodcast,
  handleClose,
  page,
  article: { selectedArticle },
}) => {
  const handleDelete = (e) => {
    deletePodcast(selectedArticle[0].podcast_id, selectedArticle[0], page);
    handleClose();
  };
  return (
    <>
      <DialogTitle>Delete Podcast</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete {selectedArticle[0].name}?
          <br />
          <br />
          <strong>This cannot be undone.</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={(e) => handleDelete(e)} color="primary">
          Delete
        </Button>
      </DialogActions>
    </>
  );
};

const mapStateToProps = (state) => ({
  article: state.article,
});

export default connect(mapStateToProps, {
  deletePodcast,
})(DeleteForm);
